<template>
  <div>
    <div v-if="needSlove">
      <div v-for="(orderItem, indexs) in solution.children">
        <div class="product-detail"
             @click="gotoDetail(orderItem, orderItem.id)">
          <img :src="markImg" class="product-label">
          <div class="block-item" style="padding-top: 10px;">
            <div class="block-address">
              <img class="largeIcon" :src=baseurl />
              <div class="item-detail" v-if="orderItem.template.name">
                <span class="deep-text-color" style="font-size: 12px;">
                   <span>
                     {{orderItem.template.externalName}}
                  </span>
                </span>
                <span class="light-text-color tiny-font">
                  {{orderItem.briefInfoDetail}}
                </span>
                <span class="light-text-color tiny-font">
                  {{getRightPu(orderItem.children) !== null ? getRightPu(orderItem.children).template ? getRightPu(orderItem.children).template.name : '' : ''}}
                </span>
              </div>
              <div class="item-detail" v-else>
                <span class="deep-text-color" style="font-size: 12px;">
                   <span>
                     实物返还
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="price-info">
            <span style="text-decoration: line-through;" class="light-text-color tiny-font" v-if="orderItem.standardPrice !== orderItem.formalQuotePrice">¥{{emkt.formatPrice(orderItem.standardPrice)}}</span>
            <span class="research-font-color bold-text">¥{{emkt.formatPrice(orderItem.formalQuotePrice)}}</span>
          </div>
          <div class="split-line"></div>
        </div>
      </div>
      <div class="block-item" style="height: 30px;" v-if="this.solution.standardPrice !== this.solution.formalQuotePrice">
        <span class="light-text-color"
              >折后价小记</span>
        <div style="display: flex; justify-content: flex-end;">
          <span style="text-decoration: line-through;" class="light-text-color tiny-font" >¥{{emkt.formatPrice(this.solution.standardPrice)}}</span>
          <span class="research-font-color bold-text">¥{{emkt.formatPrice(this.solution.formalQuotePrice)}}</span>
        </div>
      </div>
      <div class="block-item" style="height: 30px;"v-if="!this.$parent.$parent.useDiscountCouponOnly && orderCouponsValue">
        <span class="light-text-color">现金券</span>
        <span class="bold-text alert-text">- ¥{{emkt.formatPrice(orderCouponsValue)}}</span>
      </div>
      <div class="full-split-line"></div>
      <div class="block-item" style="height: 40px;">
        <span class="light-text-color">共{{order.length}}件商品</span>
        <div>
          <span class="light-text-color">总计</span>
          <span class="research-font-color bold-text" style="font-size: 16px;">¥{{emkt.formatPrice(this.order.totalPrice)}}</span>
        </div>
      </div>
    </div>
    <div v-else>
      <!--订单详情-->
      <div v-for="(orderItem, indexs) in order">
        <div class="product-detail"
             @click="gotoDetail(orderItem)"
             v-for="(merchandise, index) in orderItem.allData.boSolution.children">
          <img :src="markImg" class="product-label">
          <div class="block-item" style="padding-top: 10px;">
            <div class="block-address">
              <img class="largeIcon" :src=baseurl />
              <div class="item-detail" v-if="merchandise.template.name">

                <span class="deep-text-color" style="font-size: 12px;">
                   <span>
                     {{merchandise.template.name}}
                  </span>
                </span>
                <span class="light-text-color tiny-font">
                  {{orderItem.userLabel}}
                </span>
                <span class="light-text-color tiny-font">
                  {{orderItem.boSignalAnalysis}}
                </span>
              </div>
              <div class="item-detail" v-else>
                <span class="deep-text-color" style="font-size: 12px;">
                   <span>
                     实物返还
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="price-info">
            <span style="text-decoration: line-through;" class="light-text-color tiny-font" v-if="merchandise.standardPrice !== merchandise.formalQuotePrice">¥{{emkt.formatPrice(merchandise.standardPrice)}}</span>
            <span class="research-font-color bold-text">¥{{emkt.formatPrice(merchandise.formalQuotePrice)}}</span>
          </div>
          <div class="split-line"></div>
        </div>
      </div>
      <div class="block-item" style="height: 30px;"v-if="this.solutionPrice.standardPrice !== this.solutionPrice.formalQuotePrice">
        <span class="light-text-color">折后价小记</span>
        <div style="display: flex; justify-content: flex-end;">
          <span style="text-decoration: line-through;" class="light-text-color tiny-font">¥{{emkt.formatPrice(this.solutionPrice.standardPrice)}}</span>
          <span class="research-font-color bold-text">¥{{emkt.formatPrice(this.solutionPrice.formalQuotePrice)}}</span>
        </div>
      </div>
      <div class="block-item" style="height: 30px; "v-if="!this.$parent.$parent.useDiscountCouponOnly && $parent.$parent.couponDiscount">
        <span class="light-text-color">现金券</span>
        <span class="bold-text alert-text">- ¥{{emkt.formatPrice($parent.$parent.couponDiscount)}}</span>
      </div>
      <div class="full-split-line"></div>
      <div class="block-item" style="height: 40px;">
        <span class="light-text-color">共{{order.length}}件商品</span>
        <div>
          <span class="light-text-color">总计</span>
          <span class="research-font-color bold-text" style="font-size: 16px;">¥{{emkt.formatPrice(this.solutionPrice.formalQuotePrice)}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
  import mark from '../../../static/img/serviceMark.png'
  import {boSignalAnalysisTemplateNo} from '../../util/templateToUserData'
  export default {
    props: ['order', 'service', 'needSlove'],
    data () {
      return {
        solution: {},
        orderCouponsValue: null,
        baseurl: '/emktResources/resocurces/img/merchandise/service.png',
        markImg: mark,
        euNumber: [],
        couponsService: [],
        solutionPrice: {},
        productPrice: [],
        puCouponsGuid: [],
        disconnect: 0,
        puGroup: []
      }
    },
    mounted () {
      console.log(this.order, 'orders')
      if (this.needSlove) {
        this.sloveProductData()
      } else {
        this.getSolutionPrice()
      }
    },
    methods: {
      sloveProductData () {
        this.solution = this.order.solution
        this.order.coupons.forEach(item => {
          this.orderCouponsValue += item.value
        })
        this.$weui.loading('正在加载数据~').hide()
      },
      getRightPu (puArr) {
        if (puArr) {
          let arr = boSignalAnalysisTemplateNo()
          let pu = {}
          puArr.some(it => {
            if (arr.includes(it.template.templateNo)) {
              pu = it
              return true
            }
          })
          return pu
        } else {
          return null
        }
      },
      getSolutionPrice () {
        console.log('获取价格组件', '已调用')
        // 订单详情，数据源自于父组件传递，父组件值源于购物车isChecked为true的值，中间无任何处理
        console.log(this.order)
        // 设定EU的存放数组
        let children = []
        // 遍历循环order，将所有allData.boSolution.children的所有元素提取出来存放到数组中，并记录每个children的长度到euNumber中
        this.order.forEach(item => {
          this.euNumber.push(item.allData.boSolution.children.length)
          item.allData.boSolution.children.forEach(items => {
            children.push(items)
          })
        })
        console.log('各商品EU数量', 'EU组合后')
        console.log(this.euNumber, children)
        // 拼凑方案
        this.solution = {
          'id': -100,
          'children': children
        }
        console.log(this.solution, '方案')
        this.gcapi('getServiceProductPriceAndCoupons', {'solutionJsons': [JSON.stringify(this.solution)]}).then((res) => {
          console.log(res.body, '价格接口返回')
          this.couponsService = res.body.result.coupons
          console.log('该商品可用的优惠券', this.couponsService)
          this.solutionPrice = JSON.parse(res.body.result.solutionJson)
          console.log('该商品返回的价格', this.solutionPrice)
          this.solution.children.forEach((item, index) => {
            item.formalQuotePrice = this.solutionPrice.children[index].formalQuotePrice
            item.standardPrice = this.solutionPrice.children[index].standardPrice
          })
          let from = 0 // 这个确定从this.solutionPrice.children的第几个开始获取。
          this.order.forEach((item, index) => {
            for (let i = 0; i < this.euNumber[index]; i++) {
              item.allData.boSolution.children[i] = this.solution.children[from]
              from = from + 1
            }
          })
          this.$emit('SE', [this.solutionPrice.formalQuotePrice])
          this.solutionPrice.children.forEach(i => {
            i.children.forEach(it => {
              // console.log(it, 'sssssssssssssit s')
              if (it.promotionGuid) {
                this.puGroup.push(it)
                this.puCouponsGuid.push(it.promotionGuid)
              }
            })
          })
          this.$weui.loading('正在加载数据~').hide()
          this.$parent.$parent.getAvailableCoupons(this.couponsService, this.solutionPrice)
          this.$parent.$parent.setDefaultSelectedCoupons()
          if (this.$parent.$parent.useDiscountCouponOnly) {
            let special = 0
            this.puGroup.forEach(i => {
              if (i.promotionGuid === this.$parent.$parent.specialGuid) {
                special = special + (-i.discountPrice)
              }
            })
            this.$parent.$parent.specialDiscountPrice = special
          }
        })
      },
      getSolutionPriceAgain () {
        // 订单详情，数据源自于父组件传递，父组件值源于购物车isChecked为true的值，中间无任何处理
        // 设定EU的存放数组
        let children = []
        // 遍历循环order，将所有allData.boSolution.children的所有元素提取出来存放到数组中，并记录每个children的长度到euNumber中
        this.order.forEach(item => {
          this.euNumber.push(item.allData.boSolution.children.length)
          item.allData.boSolution.children.forEach(items => {
            children.push(items)
          })
        })
        // 拼凑方案
        this.solution = {
          'id': -100,
          'children': children
        }
        this.gcapi('getServiceProductPriceAndCoupons', {'solutionJsons': [JSON.stringify(this.solution)], 'coupons': this.$parent.$parent.selectedCoupons}).then((res) => {
          console.log(res.body, '价格接口返回')
          console.log('该商品可用的优惠券', this.couponsService)
          this.solutionPrice = JSON.parse(res.body.result.solutionJson)
          console.log('该商品返回的价格', this.solutionPrice)
          this.solution.children.forEach((item, index) => {
            item.formalQuotePrice = this.solutionPrice.children[index].formalQuotePrice
            item.standardPrice = this.solutionPrice.children[index].standardPrice
          })
          let from = 0 // 这个确定从this.solutionPrice.children的第几个开始获取。
          this.order.forEach((item, index) => {
            for (let i = 0; i < this.euNumber[index]; i++) {
              item.allData.boSolution.children[i] = this.solution.children[from]
              from = from + 1
            }
          })
          this.$emit('SE', [this.solutionPrice.formalQuotePrice])
          this.solutionPrice.children.forEach(i => {
            i.children.forEach(it => {
              if (it.promotionGuid) {
                this.puGroup.push(it)
                this.puCouponsGuid.push(it.promotionGuid)
              }
            })
          })
          this.$parent.$parent.getAvailableCoupons(this.couponsService, this.solutionPrice)
          if (this.$parent.$parent.useDiscountCouponOnly) {
            let special = 0
            this.puGroup.forEach(i => {
              if (i.promotionGuid === this.$parent.$parent.specialGuid) {
                special = special + (-i.discountPrice)
              }
            })
            this.$parent.$parent.specialDiscountPrice = special
          }
        })
      },
      gotoDetail (orderSolution, euId) {
        if (this.needSlove) {
          console.log(euId, orderSolution, this.order)
          this.$router.push({name: 'boSolutionDetail', params: {orderId: this.order.id, euId: euId}})
        } else {
          this.$router.push({name: 'boSolutionDetail', params: {orderInfo: orderSolution}})
        }
      }
    }
  }
</script>

<style scoped>
  .product-detail {
    position: relative;
  }
  .product-label {
    z-index: 5;
    width: 30px;
    position: absolute;
    top: 0;
    left: -15px;
  }
  .text-overflow-hidden {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tiny-font {
    font-size: 12px;
    transform: scale(0.8);
    transform-origin: left center;
  }
  .deep-text-color {
    color: #424242;
    font-size: 14px;
    font-weight: bold;
  }
  .bold-text {
    font-weight: bold;
  }
  .light-text-color {
    color: #929292;
    font-size: 12px;
  }
  .alert-text {
    color: #FE654D;
  }
  .largeIcon {
    position: relative;
    margin-right: 1.33vw;
    width: 13.87vw;
    height: 13.87vw;
  }
  .content-block {
    position: relative;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 0 15px;
    border-radius: 10px;
    width: 100%;
    background-color: #fff;
  }

  .block-item {
    /*height: 62px;*/
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }
  .block-address {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 90%;
  }
  .item-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
    width: 75%;
  }

  .price-info {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .split-line {
    border-top: .5px solid #efeef3;
    margin-right: -15px;
    height: 1px;
  }
  .full-split-line {
    border-top: .5px solid #efeef3;
    margin-right: -15px;
    margin-left: -15px;
    height: 1px;
  }

</style>



// WEBPACK FOOTER //
// ServiceProduct.vue?445e65ba